<template>
  <div class="productspage">
       <Loader v-if="loader == true" />
       <div 
            v-else
            class="productspage__product__id" 
            v-for="product in productsId"
            :key="product.id"
       >
           <div class="productspage__product__id__flex">
               <div class="productspage__product__id__flex_l">
                   <SlideProduct v-bind:img="product.img"/>
               </div>
               <div class="productspage__product__id__flex_r">
                   <div v-if="product.remain <= 0" class="remain_null">
                        <p>
                            Нет в продаже
                        </p>
                    </div>
                   <div class="productspage__product__id__flex_r__title">
                       <h1>{{product.title}}</h1>
                   </div>
                   <div class="productspage__product__id__flex_r__btn_price">
                       <div v-if="product.stock_id !== 0" class="flex_productspage__product__id_price">
                           <div class="flex_productspage__product__id_price_two" v-if="product.stock_price != null">
                               <div class="productspage__product__id_price">
                                        <p>
                                            <span>{{product.stock_price | numeral('0,0')}}</span> ₸
                                        </p>
                                </div>
                                <div class="productspage__product__id_price">
                                    <p class="stock_price">
                                            <strike>{{product.price | numeral('0,0')}}</strike> ₸
                                        </p>
                                </div>
                            </div>

                            <div v-else class="productspage__product__id_price">
                                    <p>
                                        <span>{{product.price | numeral('0,0')}}</span> ₸
                                    </p>
                            </div>
                       </div>
                       <div v-else class="productspage__product__id_price">
                                <p>
                                    <span>{{product.price | numeral('0,0')}}</span> ₸
                                </p>
                        </div>
                        <div v-if="product.remain <= 0" class="productspage__product__id_add_basket" title="Оформить предзаказ" @click="addToCart(product.id)">
                           <p><span class="mdi mdi-basket-fill"></span>Оформить предзаказ</p>
                       </div>
                       <div v-if="product.remain > 0" class="productspage__product__id_add_basket" title="Добавить в корзину" @click="addToCart(product.id)">
                           <p><span class="mdi mdi-basket-fill"></span> В корзину</p>
                       </div>
                       <div class="productspage__product__id_favorites" title="Добавить в избранное" @click="addToFavorite(product.id)">
                           <p>
                               <span class="mdi mdi-heart-outline"></span>
                               Добавить в избранное
                           </p>
                       </div>
                   </div>
                   <div class="type_products">
                        <div 
                            class="type_products_block"
                            v-for="defaultProductsId in defaultProducts"
                            :key="defaultProductsId.id"
                            :title="defaultProductsId.title"
                            :class="{'activeType': defaultProductsId.id == product.id}"
                            @click="updateTypeProduct(defaultProductsId)"
                        >
                            <img :src="'https://ecodom04.com/backend/' + defaultProductsId.img[0]" alt="">
                        </div>
                        <div 
                            class="type_products_block"
                            v-for="set_productsId in defaultSetProducts"
                            :key="set_productsId.id"
                            :title="set_productsId.title"
                            :class="{'activeType': set_productsId.id == product.id}"
                            @click="updateTypeProduct(set_productsId)"
                        >
                            <img :src="'https://ecodom04.com/backend/' + set_productsId.img[0]" alt="">
                        </div>
                         
                   </div>
                   <div class="productspage__product__descriptions">
                       <p>
                           {{product.description}}
                       </p>
                   </div>
               </div>
               <div class="tab__main">
                    <v-card>
                        <v-toolbar flat color="#680" dark>
                            <v-toolbar-title class="more__details">Подробнее о товаре</v-toolbar-title>
                        </v-toolbar>
                            <v-tabs 
                                background-color="#680"
                                color="#fff"
                                :centered="true"
                            >
                                <v-tab class="tab_list">
                                    <v-icon class="mob_icon_hide" left>mdi-clipboard-list</v-icon>
                                    Состав
                                </v-tab>
                                <v-tab class="tab_list">
                                    <v-icon class="mob_icon_hide" left>mdi-comment</v-icon>
                                    Коментарии
                                </v-tab>

                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                        <div class="productspage__product__id_composition">
                                                <p>
                                                        {{product.composition}}
                                                </p>
                                            </div>
                                            <div class="productspage__product__id_nutritional">
                                                <p>
                                                        {{product.nutritional}}
                                                </p>
                                            </div>
                                            <div class="productspage__product__id_expiration_date">
                                                <p><b>Срок годности:</b> {{product.expiration_date}}</p>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat>
                                        <v-card-text>
                                            <div v-if="USER.length == 0" class="button_view_comment">
                                                    <button  @click="regComments">Написать отзыв</button>
                                            </div>
                                            <div  v-if="USER.length != 0" class="main_view_comme">
                                                <div class="button_view_comment">
                                                        <button  @click="viewComments = !viewComments">Написать отзыв</button>
                                                </div>
                                                <div v-show="viewComments" class="comment_form_req">
                                                        <p>Написать отзыв</p>
                                                        <star-rating :show-rating="false" v-model="rating"></star-rating>
                                                        <textarea placeholder="Комментарий" v-model.trim="comment"></textarea>
                                                        <div class="error" v-if="$v.comment.$dirty && !$v.comment.required">Поле комментарий обязателен к заполнению</div>

                                                        <button @click="addComment">Оставить отзыв</button>
                                                </div>
                                            </div>
                                            <div class="not_comments" v-show="comments.message == 'Object with this data not found'">
                                                <p>
                                                    Нет комментариев
                                                </p>
                                            </div>
                                            <div class="list_comment_for" v-show="comments.message != 'Object with this data not found'">
                                                <div 
                                                    class="list__commnets"
                                                    v-for="commentsId in comments"
                                                    :key="commentsId.id"
                                                >
                                                    <div class="date__comments">
                                                        <p>
                                                        {{commentsId.created_at}}
                                                        </p>
                                                    </div>
                                                    <h4>{{commentsId.user}}</h4>
                                                    <star-rating v-show="commentsId.rating != null" :read-only="true" :star-size="15" :show-rating="false" v-model="commentsId.rating"></star-rating>
                                                    <p>
                                                        {{commentsId.text}}
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                    </v-card>
               </div>
           </div>
       </div>
  </div>
</template>

<script>
import SlideProduct from '@/components/SlideProduct'
import Loader from '@/components/Loader'
import {mapActions, mapGetters} from 'vuex'
import StarRating from 'vue-star-rating'
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'


export default {
  name: 'productspage',
   data () {
      return {
        id: this.$route.params.id,
        productsId: [],
        comments: [],
        loader: true,
        viewComments: false,
        rating: 1,
        comment: '',
        defaultProducts: [],
        defaultSetProducts: [],
      }
    },
    validations: {
        comment: {
            required
        },
    },
    components: {
        SlideProduct, Loader, StarRating
    },
    methods: {
        updateTypeProduct(products) {
            this.productsId = []
            this.productsId.push(products)
        },
        addComment() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return 
            } else {
                let commentData = {
                    rating: this.rating,
                    text: this.comment,
                    product_id: this.id
                } 
                axios({
                    method: 'post',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    url: this.$apiURI + 'public/comment/create',
                    data: {
                        token: this.USER[0],
                        data: JSON.stringify(commentData)
                    }
                })
                .then((response) => {
                    if (response.data.message == "Created successfully!") {
                        this.$toasted.show('Комментарий добавлен').goAway(2000)
                        this.comment = ''
                        this.getHitComment()
                    }
                })  
                .catch((error) => {
                    console.log(error);
                });
            }
        },
        getProductsId() {
            fetch(this.$apiURI + 'public/product/get?data={"id": "' + this.id + '"}')
            .then((res) => {
                res.json().then((data) => {
                    this.productsId = data
                    this.defaultProducts = data
                    data.map(item => {
                         this.defaultSetProducts = item.set_products
                    })
                    this.loader = false
                });
            })
        },
        getHitComment() {
            fetch(this.$apiURI + 'public/comment/get?data={"product_id": "' + this.id + '"}')
            .then((res) => {
                res.json().then((data) => {
                    this.comments = data
                    console.log(this.comments)

                });
            })
        },
        ...mapActions([
          'ADD_TO_CART',
          'ADD_TO_FAVORITE'
        ]),
        addToCart(id){
          this.ADD_TO_CART({
                id: id,
                img: this.productsId[0].img[0],
                title: this.productsId[0].title,
                price: this.productsId[0].price,
                quantity: 1,
                oldprice: this.productsId[0].price,
                description: this.productsId[0].description,
                remain: this.productsId[0].remain,
          })
          this.$toasted.show('Добавлен в корзину').goAway(1500)
        },
        addToFavorite(id) {
            this.ADD_TO_FAVORITE({
                id: id,
                img: this.productsId[0].img[0],
                title: this.productsId[0].title,
                price: this.productsId[0].price,
                description: this.productsId[0].description,
           })
           this.$toasted.show('Добавлен в избранное').goAway(1500)
        },
        regComments() {
           this.$toasted.show('Зарегистрируйтесь чтобы оставить отзыв').goAway(3000)
        }
    },
    mounted() {
      this.getProductsId()
      this.getHitComment()
    },
    computed: {
        ...mapGetters(['USER'])
    }
}
</script>

<style scoped lang="less">
@baseMedia: 900px;

.productspage {
    width: 1200px;
    background: #fff;
    margin: 0 auto;
    overflow: hidden;
    @media (max-width: @baseMedia) {
        width: 95%;
        flex-wrap: wrap;
    }
    .productspage__product__id {
        width: 97%;
        margin: 0 auto;
        border: 1px solid #ccc;
        margin-top: 20px;
        margin-bottom: 20px;
        .productspage__product__id__flex {
            width: 97%;
            margin: 0 auto;
            margin-top: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            @media (max-width: @baseMedia) {
                flex-wrap: wrap;
                justify-content: center;
            }
            .productspage__product__id__flex_l {
                width: 30%;
                @media (max-width: @baseMedia) {
                    width: 100%;
                }
            }
            .productspage__product__id__flex_r {
                width: 67%;
                position: relative;
                @media (max-width: @baseMedia) {
                    width: 100%;
                }
                .remain_null {
                    padding: 5px 10px;
                    color: #fff;
                    font-weight: bold;
                    background: red;
                    position: absolute;
                    top: 0;
                    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.75);
                    right: 0;
                }
                .productspage__product__id__flex_r__title {
                    width: 100%;
                    text-align: left;
                    @media (max-width: @baseMedia) {
                        margin-top: 25px;
                    }
                    h1 {
                        font-weight: normal;
                        @media (max-width: @baseMedia) {
                            font-size: 25px;
                        }
                    }
                }
                .productspage__product__id__flex_r__btn_price {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 30px;
                    @media (max-width: @baseMedia) {
                        flex-wrap: wrap;
                        margin-top: 20px;
                    }
                    .productspage__product__id_price {
                        background: #fafaca;
                        padding: 10px 20px;
                        box-shadow: 0px 1px 6px 0px rgba(17,102,9,1);
                        p {
                            font-size: 20px;
                            color: #690;
                            span {
                                font-weight: bold;
                            }
                        }
                    }
                    .flex_productspage__product__id_price {
                        display: flex;
                        justify-content: space-between;
                        @media (max-width: @baseMedia) {
                            width: 100%;
                            background: red;
                        }
                        .flex_productspage__product__id_price_two {
                            display: flex;
                            justify-content: space-between;
                            flex-wrap: wrap;
                            @media (max-width: @baseMedia) {
                                width: 100%;
                            }
                        }
                        .productspage__product__id_price {
                            background: #fafaca;
                            padding: 10px 20px;
                            box-shadow: 0px 1px 6px 0px rgba(17,102,9,1);
                            @media (max-width: @baseMedia) {
                                width: 100%;
                                text-align: center;
                                padding: 5px;
                                background: #fff;
                            }
                            .stock_price {
                                color: red;
                            }
                            p {
                                font-size: 20px;
                                color: #690;
                                span {
                                    font-weight: bold;
                                }
                            }
                        }
                    }
                    
                    .productspage__product__id_add_basket {
                        padding: 10px 20px;
                        background: #5e8d00;
                        box-shadow: 0px 1px 6px 0px rgba(17,102,9,1);
                        @media (max-width: @baseMedia) {
                            width: 100%;
                            text-align: center;
                            padding: 6px 20px;
                        }
                        cursor: pointer;
                        &:hover {
                            opacity: 0.7;
                        }
                        p {
                            color: #fff;
                            font-size: 20px;
                            @media (max-width: @baseMedia) {
                                font-size: 16px;                                
                            }
                        }
                        span {
                            color: #fff;
                            font-weight: bold;
                            @media (max-width: @baseMedia) {
                                font-size: 16px;                                
                            }
                        }
                    }
                    .productspage__product__id_favorites {
                        box-shadow: 0px 1px 6px 0px rgba(17,102,9,1);
                        background: #fafaca;
                        cursor: pointer;
                        padding: 10px 20px;
                        @media (max-width: @baseMedia) {
                            width: 100%;
                            text-align: center;
                            padding: 6px 20px;
                        }
                        &:hover {
                            opacity: 0.7;
                        }
                        p {
                            span {
                                color: #ffcc00;
                                @media (max-width: @baseMedia) {
                                    font-size: 16px;                                
                                }
                            }
                            @media (max-width: @baseMedia) {
                                font-size: 16px;                                
                            }
                            font-weight: bold;
                            color: #000;
                            font-size: 19px;
                        }
                        
                    }
                }
                .productspage__product__descriptions {
                    width: 100%;
                    margin-top: 34px;
                    border: 2px dotted #ccc;
                    padding: 10px;
                    position: relative;
                    &::before {
                        content: 'Описание товара';
                        display: block;
                        background: #ffffff;
                        position: absolute;
                        top: -22px;
                        padding: 10px;
                        font-weight: 600;
                        border: 2px dotted #ccc;
                    }
                    p {
                        font-size: 18px;
                        margin-top: 15px;
                        @media (max-width: @baseMedia) {
                            font-size: 16px;                                
                        }
                    }
                }
                .type_products {
                    height: 60px;
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 20px;
                    .type_products_block {
                        cursor: pointer;
                        width: 69px;
                        height: 60px;
                        margin: 1px;
                        border: 2px dotted #ccc;
                        text-align: center;
                        overflow: hidden;
                        img {
                            width: auto;
                            height: 90%;
                            margin-top: 2px;
                        }
                    }
                    .activeType {
                        border: 2px dotted #5e8d00;
                    }
                }
            }
            .tab__main {
                width: 100%;
                margin-top: 20px;
                .more__details {
                    font-size: 20px;
                }
                .button_view_comment {
                    width: 100%;
                    text-align: right;
                    padding-bottom: 5px;
                    button {
                        padding: 10px;
                        border: none;
                        background: #80a537;
                        color: #fff;
                        font-weight: bold;
                        text-transform: uppercase;
                        @media (max-width: @baseMedia) {
                            width: 100%;
                            padding: 5px;
                        }
                        &:hover {
                            background: #5a7b19;
                        }
                    }
                }
                .tab_list {
                    justify-content: flex-start;
                    font-size: 14px;
                    font-weight: bold;
                    @media (max-width: @baseMedia) {
                        font-size: 11px;   
                    }
                    .mob_icon_hide {
                        display: block;
                        @media (max-width: @baseMedia) {
                            display: none;
                        }
                    }
                }
                .productspage__product__id_composition {
                    width: 100%;
                    margin-top: 20px;
                    border: 2px dotted #ccc;
                    padding: 10px;
                    position: relative;
                    margin-bottom: 35px;
                    &::before {
                        content: 'Состав';
                        display: block;
                        background: #ffffff;
                        position: absolute;
                        top: -22px;
                        padding: 3px 10px;
                        font-weight: 600;
                        color: #000;
                        border: 2px dotted #ccc;
                    }
                    p {
                        font-size: 18px;
                        margin-top: 6px;
                        color: #000;
                        @media (max-width: @baseMedia) {
                            font-size: 15px;
                        }
                    }
                }
                .productspage__product__id_nutritional {
                    width: 100%;
                    margin-top: 20px;
                    border: 2px dotted #ccc;
                    padding: 10px;
                    position: relative;
                    &::before {
                        content: 'Пищевая ценность';
                        display: block;
                        background: #ffffff;
                        position: absolute;
                        top: -22px;
                        padding: 3px 10px;
                        font-weight: 600;
                        color: #000;
                        border: 2px dotted #ccc;
                    }
                    p {
                        font-size: 18px;
                        margin-top: 6px;
                        color: #000;
                        @media (max-width: @baseMedia) {
                            font-size: 15px;
                        }
                    }
                }
                .productspage__product__id_expiration_date {
                    width: 100%;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    margin-top: 15px;
                    p {
                        color: #000;
                        font-size: 18px;
                        @media (max-width: @baseMedia) {
                            font-size: 15px;
                        }
                    }
                }
                
                .main_view_comme {
                    .button_view_comment {
                        width: 100%;
                        text-align: right;
                        padding-bottom: 5px;
                        button {
                            padding: 10px;
                            border: none;
                            background: #80a537;
                            color: #fff;
                            font-weight: bold;
                            text-transform: uppercase;
                            
                            &:hover {
                                background: #5a7b19;
                            }
                        }
                        
                    }
                    .comment_form_req {
                        width: 100%;
                        padding: 10px;
                        border: 2px dotted #ccc;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        margin-bottom: 10px;
                        .error {
                            color: red;
                            font-size: 11px;
                            margin-bottom: 10px;
                        }
                        p {
                            color: #000;
                            margin-bottom: 10px;
                            font-size: 26px;
                        }
                        textarea {
                            width: 100%;
                            border: 1px solid #ccc;
                            resize: none;
                            outline-color: #668800;
                            height: 100px;
                            padding-left: 5px;
                            padding-top: 5px;
                            margin-top: 10px;
                        }
                        button {
                            width: 100%;
                            border: none;
                            height: 40px;
                            outline: none;
                            background: #668800;
                            color: white;
                            text-transform: uppercase;
                            font-weight: bold;
                            &:hover {
                                opacity: 0.7;
                            }
                        }
                    }
                }
                 .not_comments {
                    width: 100%;
                    padding: 10px;
                    border: 2px dotted #ccc;
                    text-align: center;
                    p {
                        font-size: 20px;
                        color: #000;
                    }
                }
                .list_comment_for {
                    width: 100%;
                   
                    .list__commnets {
                        width: 100%;
                        padding: 10px;
                        padding-top: 20px;
                        border: 2px dotted #ccc;
                        position: relative;
                        margin-bottom: 10px;
                        h4 {
                            color: #000;
                            font-size: 17px;
                            @media (max-width: @baseMedia) {
                                font-size: 14px;
                                margin-top: 10px;
                            }
                        }
                        p {
                            color: #000;
                            font-size: 15px;
                            @media (max-width: @baseMedia) {
                                font-size: 14px;
                            }
                        }
                        .date__comments {
                            padding: 3px;
                            position: absolute;
                            background: #fafaca;
                            box-shadow: 0px 1px 6px 0px #116609;
                            right: 0;
                            top: 0;
                            @media (max-width: @baseMedia) {
                                padding: 1px;
                            }
                            p {
                                color: #000;
                                font-weight: bold;
                                @media (max-width: @baseMedia) {
                                    font-size: 10px;
                                }
                            }
                        }
                    }
                }
                
            }
        }
    }
}
</style>